import * as yup from 'yup';

export const shipmentSchema = yup.object().shape({
  ship_to: yup.string().required('is required'),
  line_items: yup.array().min(1, 'must have at least one line items').required('is required'),
});
